import { common, orange } from '@material-ui/core/colors';
import accent from './accent';

const error = {
    contrastText: common.white,
    dark: accent.redDark,
    light: accent.redLight,
    main: accent.redMain,
    warning: orange[600],
};
export default error;
